import { render, staticRenderFns } from "./ReportByBrand.vue?vue&type=template&id=3a5b0716&scoped=true&"
import script from "./ReportByBrand.vue?vue&type=script&lang=js&"
export * from "./ReportByBrand.vue?vue&type=script&lang=js&"
import style0 from "./ReportByBrand.vue?vue&type=style&index=0&id=3a5b0716&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5b0716",
  null
  
)

export default component.exports